@use "diy_base.module.scss";
@use "foundation/responsive";

.diy-composer {
  display: flex;
  align-items: center;
  flex-direction: column;

  margin-top: diy_base.$diy-composer-margin;

  @include responsive.phone {
    margin-top: diy_base.$diy-composer-margin-phone;
    margin-bottom: diy_base.$diy-composer-margin-phone;
  }

  &.filter-code-view {
    margin-top: 0 !important;
  }

  &.has-bottom-bar {
    padding-bottom: 5em;
    @include responsive.phone {
      padding-bottom: 7em;
    }
  }

  ul.creation-mode-switcher {
    width: diy_base.$box-width;
    margin-bottom: 2em;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    @include responsive.phone {
      width: diy_base.$box-width-phone;
    }

    li {
      font-weight: 700;
      line-height: 1.375em;
      cursor: pointer;
      box-sizing: border-box;
      border-bottom: 4px solid;
      border-color: transparent;
    }

    li.selected {
      border-color: inherit;
    }

    li:last-child {
      margin-left: 64px;
    }
  }

  section.mode-containers {
    width: 100%;
  }
}

.tooltip {
  margin-top: -2em; /* 36px */
  margin-bottom: 2.56em; /* 46px */
}
